module.exports = __webpack_public_path__ + "img/job-description.433aa742.svg";